import React, { createContext, useContext, ReactNode } from "react";
import { canAct, getStaffTier, isStaff, StaffTier } from "../auth/oidc";

interface Capabilities {
  isStaff: boolean;
  canAct: boolean;
  tier: StaffTier;
}

const CapabilitiesContext = createContext<Capabilities>({
  isStaff: false,
  canAct: false,
  tier: null,
});

export const CapabilitiesProvider = ({ children }: { children: ReactNode }) => {
  const capabilities: Capabilities = {
    isStaff: isStaff(),
    canAct: canAct(),
    tier: getStaffTier(),
  };
  return (
    <CapabilitiesContext.Provider value={capabilities}>
      {children}
    </CapabilitiesContext.Provider>
  );
};

export const useCapabilities = (): Capabilities =>
  useContext(CapabilitiesContext);
